import React from 'react';
import GlassCard from './GlassCard';

function SkillCard({ skill }) {
  const Icon = skill.icon;

  return (
    <GlassCard className="skill-card">
      <div className="skill-icon">
        <Icon />
      </div>
      <h3 className="skill-title">{skill.title}</h3>
      <p className="skill-description">{skill.description}</p>
      <div className="skill-type">
        {skill.typeIcon} {skill.type}
      </div>
    </GlassCard>
  );
}

export default SkillCard;
